module.exports = __webpack_public_path__ + "img/cinta.0afd377b.jpg";